// Pure index math for DropdownComponent menu keyboard navigation.

// The index to focus after `key`. `current` is -1 when no item has focus.
// Arrows wrap; Home and End jump. Returns -1 when there are no items.
export function nextIndex(count, current, key) {
  if (count <= 0) return -1;

  switch (key) {
    case "ArrowDown":
      return current < 0 ? 0 : (current + 1) % count;
    case "ArrowUp":
      return current < 0 ? count - 1 : (current - 1 + count) % count;
    case "Home":
      return 0;
    case "End":
      return count - 1;
    default:
      return current;
  }
}

// The index of the next label after `current` that starts with `char`
// (case-insensitive), wrapping and ending on `current` itself. Returns -1
// when nothing matches.
export function typeaheadIndex(labels, current, char) {
  const needle = char.toLowerCase();
  const count = labels.length;

  for (let step = 1; step <= count; step++) {
    const index = (current + step + count) % count;
    if (labels[index].trim().toLowerCase().startsWith(needle)) return index;
  }
  return -1;
}
